export const STATUS_ORDER =[
    "Draft",
    "Submitted",
    "Under Review",
    "In Progress",
    "On Hold",
    "Canceled",
    "Completed",
    "Closed"
  ];
 

export const STATUS_RULES = {
  "Draft": {
    canEdit: true,
    canDelete: true,
    canSubmit: true,
    nextStatuses: ["Submitted"],
    cannotGoBack: true
  },
  "Submitted": {
    canEdit: true,
    canDelete: false,
    canSubmit: false,
    nextStatuses: ["Under Review", "On Hold"],
    cannotGoBack: true
  },
  "Under Review": {
    canEdit: true,
    canDelete: false,
    canSubmit: false,
    nextStatuses: ["In Progress", "On Hold", "Canceled"],
    cannotGoBack: false
  },
  "In Progress": {
    canEdit: true, // Limited edit: Job Requirement becomes read-only, Job Actuals editable
    canDelete: false,
    canSubmit: false,
    nextStatuses: ["Completed", "On Hold", "Canceled", "Under Review"],
    cannotGoBack: false
  },
  "On Hold": {
    canEdit: false,
    canDelete: false,
    canSubmit: false,
    nextStatuses: ["In Progress", "Under Review", "Canceled"],
    cannotGoBack: true
  },
  "Canceled": {
    canEdit: false,
    canDelete: false,
    canSubmit: false,
    nextStatuses: [],
    cannotGoBack: true
  },
  "Completed": {
    canEdit: false,
    canDelete: false,
    canSubmit: false,
    nextStatuses: ["Closed"],
    cannotGoBack: true
  },
  "Closed": {
    canEdit: false,
    canDelete: false,
    canSubmit: false,
    nextStatuses: [],
    cannotGoBack: true
  }
};

  

  
export const getStatusRules = (currentStatus) => {
  return STATUS_RULES[currentStatus] || {};
};
  
// const currentStatus = "Under Review";
// const rules = getStatusRules(currentStatus);

// console.log("Can Edit:", rules.canEdit); // true
// console.log("Next Status Options:", rules.nextStatuses); // ["Assessment / Estimate / Work Order", "On Hold", "Canceled"]

export const canTransition = (currentStatus, nextStatus) => {
    const rules = getStatusRules(currentStatus);
    return rules.nextStatuses.includes(nextStatus);
  };
  
// const nextStatus = "Submitted";
// if (canTransition(currentStatus, nextStatus)) {
//   console.log("Transition allowed");
// } else {
//   console.log("Transition NOT allowed");
// }
